import * as React from 'react';

import { useSafeLayoutEffect } from './useSafeLayoutEffect';

/**
 * Return true if the browser is currently hydrating DOM generated from SSR.
 */
export function useIsHydrating() {
    const [isHydrating, setIsHydrating] = React.useState(true);

    useSafeLayoutEffect(() => {
        setIsHydrating(false);
    }, []);

    return isHydrating;
}
